<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap px-12 mx-12>
            <v-flex xs4>
                <h1>Completed Tasks</h1>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-flex>
            <v-flex xs8 class="text-right">
                <v-btn color="primary" dark outlined :to="'/management/tasks/active'">Active</v-btn>
                <v-btn color="neutral" class="ml-2" dark :to="'/management/tasks/archived'">Archived</v-btn>
                <v-btn color="orange ml-2" dark :to="'/management/tasks/delayed'">Delayed</v-btn>
                <v-btn color="purple ml-2" dark :to="'/management/tasks/inprogress'">In Progress</v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap px-12 mx-12>
            <v-flex xs12>
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="completedJobTasksDisplay"
                        :search="search"
                        item-key="name"
                        multi-sort
                        class="elevation-1 task-table">
                        <template v-slot:item.action="{ item }">
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="blue"
                                        @click="handleDetails(item)">
                                        mdi-information-outline
                                    </v-icon>
                                </template>
                                <span>Task Details</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on }">
                                    <v-icon
                                        v-on="on"
                                        class="mr-2"
                                        color="black"
                                        @click="archiveDialogForJobTask(item)">
                                        mdi-archive
                                    </v-icon>
                                </template>
                                <span>Archive Task</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>

        <archive-jobTask
            :showDialog="archiveJobTaskDialog"
            :toggle="toggleArchive"
            :jobTask="jobTaskToArchive">
        </archive-jobTask>
        <jobTask-details
            :showDialog="detailsJobTaskModal"
            :toggle="toggleDetails"
            :jobTask="jobTaskForDetails">
        </jobTask-details>

    </v-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Helpers from  '@/utils/helpers/jobTaskHelpers'
    import ArchiveJobTask from '@/components/jobTasks/Archive'
    import JobTaskDetails from  '@/components/jobTasks/Details'

    export default {
        name: 'CompletedTasks',
        components: {
            ArchiveJobTask,
            JobTaskDetails
        },
        created () {
            this.loadCompletedJobTasks()
        },
        data () {
            return {
                archiveJobTaskDialog: false,
                createJobTaskDialog: false,
                detailsJobTaskModal: false,
                index: null,
                jobTaskToArchive: {},
                jobTaskToUpdate: {},
                jobTaskForDetails: {},
                routes: [],
                search: '',
            }
        },

        methods: {
            ...mapActions({
                loadCompletedJobTasks: 'jobTasks/getCompleted',
                getTask: 'jobTasks/getById'
            }),
            createJobTaskCallback() {
                this.createJobTaskDialog = true;
            },
            toggleCreate() {
                this.createJobTaskDialog = !(this.createJobTaskDialog)
            },
            toggleArchive() {
                this.archiveJobTaskDialog = !(this.archiveJobTaskDialog)
            },
            toggleDetails() {
                this.detailsJobTaskModal = !(this.detailsJobTaskModal)
            },
            archiveDialogForJobTask(item) {
                this.jobTaskToArchive = item.jobTask
                this.toggleArchive()
            },
            handleDetails(item) {
                this.jobTaskForDetails = item.jobTask
                this.getTask(item.jobTask.id)
                this.toggleDetails()
            },
        },
        computed: {
            ...mapGetters({
                completedJobTasks: 'jobTasks/completedJobTasks',
                headers: 'jobTasks/headers',
                error: 'jobTasks/error',
            }),
            completedJobTasksDisplay: function () {
                return Helpers.display(this.completedJobTasks)
            }
        }
    }
</script>

<style>
    .task-table{
        table-layout : fixed;
    }
</style>
